import { Injectable } from "@angular/core";
import { ApiService } from "../api.service";
import { UserNotificationDTO } from "../notifications/UserNotificationDTO";

const PATH = "user-notifications";

@Injectable({
  providedIn: "root",
})
export class UserNotificationsHandlerService {
  constructor(private apiService: ApiService) {}

  userNotificationsGet(
    account_app_id: number,
    perPage?: number,
    page?: number,
  ) {
    return this.apiService.get(
      `${PATH}/${account_app_id}${perPage || page ? "?" : ""}${
        perPage ? "perPage=" + perPage : ""
      }${perPage && page ? "&" : ""}${page ? "page=" + page : ""}`,
    );
  }

  userNotificationsPut(userNotification: UserNotificationDTO) {
    return this.apiService.put(
      `${PATH}/${userNotification.account_app_id}/${userNotification.id}`,
      userNotification,
    );
  }

  userNotificationsDelete(userNotification: UserNotificationDTO) {
    return this.apiService.delete(
      `${PATH}/${userNotification.account_app_id}/${userNotification.id}`,
    );
  }

  markAllAsRead(account_app_id: number) {
    return this.apiService.post(`${PATH}/${account_app_id}/markAllAsRead`, {});
  }

  deleteAll(account_app_id: number) {
    return this.apiService.post(`${PATH}/${account_app_id}/deleteAll`, {});
  }

  unreadCount(account_app_id: number) {
    return this.apiService.get(`${PATH}/${account_app_id}/unreadCount`);
  }
}
